import { Injectable } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

declare global {
  interface Window {
    dataLayer: any[];
  }
}

@Injectable({
  providedIn: 'root',
})
export class AnalyticsService {
  constructor(private route: ActivatedRoute) {
    this.checkAndPushUrlParams();
  }

  private checkAndPushUrlParams(): void {
    // Subscribe to queryParams to handle changes if the user navigates without a full page reload.
    this.route.queryParams.subscribe(params => {
      const utmSource = params['utm_source'];
      const ref = params['ref'];

      if (utmSource || ref) {
        // Ensure dataLayer is initialized
        window.dataLayer = window.dataLayer || [];

        // Push the parameters to the dataLayer
        window.dataLayer.push({
          event: 'url_params_present',
          url_utm_source: utmSource,
          url_ref: ref,
        });
      }
    });
  }
}
